/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import _ from 'lodash';
import SimpleInput from '/client/src/components/forms/simpleInput';
import Switcher from '/client/src/components/switcher';
import EventDetailsTicketAdvSet from './advSettings';
import validateTicketLevels from '../validator/ticketLevels';
import FeeTooltip from './../feeTooltip';
import { currency } from '/client/src/constants/';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';

import './styles.scss';

type PropsType = {
  handleControlTicketData?: (number) => void,
  data: any,
  id?: number | string
};

const TicketLevelItem = (props: PropsType): React.Fragment => {
  const context = React.useContext(DefaultContainerContext);

  const _id = props.id;

  let singleLevelObjIndex = 0;

  let _tempId = -1000;

  const singleLevelObj = _.find(props.data.items, (l: {}, li: number): {} => {
    if (_.toString(l.id) === _.toString(_id)) {
      singleLevelObjIndex = li;
      _tempId = l.temp_id;

      return l;
    }
  });

  const checkEnableAdvSet = (): boolean => {
    if (!singleLevelObj) return false;

    const checkedTicket = [
      singleLevelObj.is_show_ticket_description,
      singleLevelObj.is_show_long_ticket_description,
      singleLevelObj.is_add_ticket_custom_confirmation,
      singleLevelObj.is_customize_ticket_quantity_options,
      singleLevelObj.is_customize_ticket_taxes_and_fees,
      singleLevelObj.is_set_sale_time,
      singleLevelObj.is_hide_ticket_level_from_pos,
      singleLevelObj.is_need_code_to_show
      // singleLevelObj.is_mark_ticket_level_as_sold_out
      // TODO: now hidden
    ];

    return _.some(checkedTicket);
  };

  const [name, _setName] = React.useState(singleLevelObj ? singleLevelObj.name : '');
  const [price, _setPrice] = React.useState(singleLevelObj ? +singleLevelObj.price : '');
  const [tax, _setTax] = React.useState(singleLevelObj ? +singleLevelObj.tax : '');
  const [moneyTax, _setMoneyTax] = React.useState(singleLevelObj ? +singleLevelObj.tax : '');
  const [percentage, _setPercentage] = React.useState(singleLevelObj ? +singleLevelObj.tax_percentage : '');
  const [use_percentage, _setUsePercentage] = React.useState(singleLevelObj ? +singleLevelObj.tax_use_percentage : '');
  const [merchant_fee, _setMerchantFee] = React.useState(singleLevelObj ? +singleLevelObj.merchant_fee : '');
  const [quantity, _setQuantity] = React.useState(singleLevelObj ? singleLevelObj.stock_quantity : ' ');
  const [ticketDetailAdvSetStatus, toggleTicketDetailAdvSetStatus] = React.useState(checkEnableAdvSet());
  const [isAdvSettingsVisible, toggleAdvSettingsVisible] = React.useState(true);
  const [feeTypeExclude, _setFeeTypeExclude] = React.useState(_.get(singleLevelObj, 'fee_type', 'ExcludeFee') === 'ExcludeFee');

  React.useMemo(() => {
    const tickets = props.data.items;

    tickets[singleLevelObjIndex] = {
      ...tickets[singleLevelObjIndex],
      name,
      price,
      tax,
      tax_percentage: percentage,
      tax_use_percentage: use_percentage,
      merchant_fee,
      stock_quantity: quantity,
      expand_description: !ticketDetailAdvSetStatus
    };

    props.data.handleControlTicketData(tickets);
  }, [name, price, quantity, ticketDetailAdvSetStatus, tax, merchant_fee, percentage, use_percentage]);

  const jsCTooltipRef = React.createRef();

  const setPrice = (price) => {
    _setPrice(price);
    if (use_percentage) {
      _setTax(percentage * price / 100);
    }
  };

  const setUsePercentage = (isUsePercentage) => {
    _setUsePercentage(isUsePercentage);
    if (isUsePercentage) {
      _setTax(percentage * price / 100);
    } else {
      _setTax(moneyTax);
    }
  };

  const setPercentage = (percentage) => {
    _setPercentage(percentage);
    _setTax(percentage * price / 100);
  };

  const setMoneyTax = (money) => {
    _setMoneyTax(money);
    _setTax(money);
  };

  const setSwitchState = (e: any, newStatus: boolean) => {
    toggleTicketDetailAdvSetStatus(newStatus);
  };

  React.useEffect(() => {
    validateTicketLevels(props.data);
  }, [quantity, price]);

  return (
    <div className='TicketLevelItem' data-tli={_tempId || _id}>
      <div className='panel-body-grid'>
        <SimpleInput
          name={`ticketName-${props.data.index}`}
          id={`ticketName-${props.data.index}`}
          label='Ticket Name (required)'
          dataId='name'
          value={name}
          validator={{}}
          onChange={(e: any) => {
            _setName(e.target.value);
          }}
          maxLength={128}
          isShowLimit
          limit={128}
          limitCb={props.data.setValidateDataLength}
        />

        <FeeTooltip
          {...props}
          jsCTooltipRef={jsCTooltipRef}
          ticket={props.data.items[singleLevelObjIndex]}
          tax={tax}
          merchant_fee={merchant_fee}
          price={price}
          feeTypeExclude={feeTypeExclude}
        >
          <SimpleInput
            name={`ticketPrice-${props.data.index}`}
            id={`ticketPrice-${props.data.index}`}
            label='Ticket price'
            dataId='price'
            maxLength={129}
            withAddon={currency[_.get(context, 'profileCurrent.currency', 'USD')]}
            addonPosition='start'
            value={_.toString(price / 100)}
            type='number'
            validator={{}}
            onChange={(e: any) => {
              setPrice(e.target.value * 100);
            }}
            onFocus={() => {
              jsCTooltipRef.current.classList.add('isLocked');
            }}
            onBlur={() => {
              jsCTooltipRef.current.classList.remove('isLocked');
            }}
          />
        </FeeTooltip>

        <SimpleInput
          name={`ticketQuantity-${props.data.index}`}
          id={`ticketQuantity-${props.data.index}`}
          label='Ticket quantity (required)'
          dataId='quantity'
          maxLength={129}
          value={quantity.toString()}
          type='number'
          validator={{}}
          onChange={(e: any) => {
            _setQuantity(Math.abs(e.target.value).toString());
          }}
        />
      </div>

      <hr />

      <div className="row">
        <div className="form-switcher-container">
          <Switcher
            className='form-switcher-sm pull-left'
            id={`ticketDetailAdvSetStatus-${props.data.index}`}
            index={`ticketDetailAdvSetStatus-${props.data.index}`}
            checked={ticketDetailAdvSetStatus}
            onCallback={setSwitchState}
            label='Enable advanced ticket settings'
          />
          <div
            className='form-switcher-toggler'
            onClick={(): void => toggleAdvSettingsVisible((prev: boolean): boolean => !prev)}
          >
            {isAdvSettingsVisible ? 'Hide' : 'Show'}
            <span>
              <i className={`icon icon-chevron-${isAdvSettingsVisible ? 'up' : 'down'}`} />
            </span>
          </div>
        </div>
      </div>

      {ticketDetailAdvSetStatus && isAdvSettingsVisible &&
        <>
          <hr style={{ marginTop: '1rem' }} />
            <EventDetailsTicketAdvSet
              index={props.data.index}
              ticket={singleLevelObj}
              tickets={props.data.items}
              singleTicketObjIndex={singleLevelObjIndex}
              onHandleControlTicketData={props.data.handleControlTicketData}
              __setTax={_setTax}
              __setPercantage={setPercentage}
              __setMoneyTax={setMoneyTax}
              __setUsePercantage={setUsePercentage}
              __setMerchantFee={_setMerchantFee}
              __setFeeTypeExclude={_setFeeTypeExclude}
              feeTypeExclude={feeTypeExclude}
              price={price}
              tax={tax}
              moneyTax={moneyTax}
              percentage={percentage}
              use_percentage={use_percentage}
              setValidateDataLength={props.data.setValidateDataLength}
            />
        </>
      }
    </div>
  );
};

export default TicketLevelItem;
